import { api } from '@/config/api';
import { Template, TemplateCategory, HeaderType, TemplateButton, TemplateLocation } from './templates.service';

export interface DefaultTemplate {
  _id: string;
  defaultTemplateUid: string;
  title: string;
  description?: string;
  tags: string[];
  thumbnailUrl?: string;
  name: string;
  language: string;
  category: TemplateCategory;
  headerType?: HeaderType;
  headerText?: string;
  headerImageUrl?: string;
  headerVideoUrl?: string;
  headerDocumentUrl?: string;
  headerDocumentFilename?: string;
  headerLocation?: TemplateLocation;
  body: string;
  footer?: string;
  buttons: TemplateButton[];
  previewSamples: Record<string, string>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GalleryListResponse {
  items: DefaultTemplate[];
  total: number;
  page: number;
  limit: number;
}

export interface GalleryListParams {
  q?: string;
  category?: TemplateCategory | '';
  page?: number;
  limit?: number;
}

export const templateGalleryService = {
  list: async (params: GalleryListParams = {}): Promise<GalleryListResponse> =>
    (await api.get('/slighter_crm/template-gallery', { params })).data,

  get: async (uid: string): Promise<DefaultTemplate> =>
    (await api.get(`/slighter_crm/template-gallery/${uid}`)).data,

  clone: async (uid: string): Promise<Template> =>
    (await api.post(`/slighter_crm/template-gallery/${uid}/clone`)).data,
};
